import { VFlex } from '@/package';
import type { User, UserGroup } from '@/type';
import { convertUserEmailToHexColor } from '@/util';

type UserRowProps = {
  user: User;
  userGroups?: UserGroup[];
};

const UserRow = ({ user, userGroups }: UserRowProps) => {
  const findGroupsByUser = (user: User) => {
    return (
      userGroups?.filter(group => group.users.find(u => u.id === user.id)) || []
    );
  };

  const groups = findGroupsByUser(user);

  return (
    <VFlex className="w-full items-center gap-2 overflow-hidden">
      <div
        className="flex h-5 min-h-5 w-5 min-w-5 items-center justify-center rounded-full text-body-md"
        style={{
          backgroundColor: convertUserEmailToHexColor(user.email)
            .backgroundColor,
          color: convertUserEmailToHexColor(user.email).color,
        }}
      >
        {user.profileImg ? (
          <img src={user.profileImg} />
        ) : (
          <div>{user.email[0]}</div>
        )}
      </div>

      <VFlex direction="col" className="w-full min-w-0">
        <VFlex className="w-full min-w-0 gap-2 text-body-md text-black">
          {user.name && (
            <>
              <span className="truncate">{user.name}</span>
              <div className="h-3 w-px bg-gray-300" />
            </>
          )}
          <span className="truncate">{user.email}</span>
        </VFlex>

        <VFlex>
          {groups.length ? (
            <span className="overflow-hidden text-body-md text-ellipsis whitespace-nowrap text-gray-400">
              {groups.map(({ name }) => name).join(', ')}
            </span>
          ) : (
            <span className="text-body-md text-gray-300">No group</span>
          )}
        </VFlex>
      </VFlex>
    </VFlex>
  );
};

export default UserRow;
